'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// header

var NavBar = function (_Component) {
    _inherits(NavBar, _Component);

    function NavBar(props) {
        _classCallCheck(this, NavBar);

        var _this = _possibleConstructorReturn(this, (NavBar.__proto__ || Object.getPrototypeOf(NavBar)).call(this, props));

        _this.state = {
            navBarClasses: 'nav-bar'
        };
        _this.handleMenuClick = _this.handleMenuClick.bind(_this);
        _this.handleSubNavToggle = _this.handleSubNavToggle.bind(_this);
        return _this;
    }

    _createClass(NavBar, [{
        key: 'getSportDetails',
        value: function getSportDetails(sportId, linkCat) {
            var displaySport = false;
            this.props.sports.map(function (sport) {
                if (sport.id === sportId) {
                    sport.categories.map(function (cat) {
                        if (cat === 'lineups' && linkCat === 'lineups') {
                            displaySport = true;
                        } else if (cat === 'sweatstation' && linkCat === 'sweatstation') {
                            displaySport = true;
                        } else if (cat === 'props' && linkCat === 'props') {
                            displaySport = true;
                        } else if (cat === 'multi-lineups' && linkCat === 'multi-lineups') {
                            displaySport = true;
                        }
                        return false;
                    });
                }
                return false;
            });
            return displaySport;
        }
    }, {
        key: 'handleMenuClick',
        value: function handleMenuClick() {
            var newClass = 'nav-bar';
            if (this.state.navBarClasses === 'nav-bar') {
                newClass = 'nav-bar nav-open';
            }
            this.setState({
                navBarClasses: newClass
            });
        }
    }, {
        key: 'handleSubNavToggle',
        value: function handleSubNavToggle(el) {
            var thisElement = document.getElementById(el);
            var newClassList = 'menu-item menu-item-type-custom menu-item-object-custom menu-item-has-children menu-item-14874 has-dropdown';
            if (thisElement !== null) {
                if (thisElement.classList.contains('toggle-sub') === false) {
                    newClassList = 'menu-item menu-item-type-custom menu-item-object-custom menu-item-has-children menu-item-14874 has-dropdown toggle-sub';
                }
                thisElement.setAttribute('class', newClassList);
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var navBar = _react2.default.createElement(
                'nav',
                { className: 'bg-dark' },
                _react2.default.createElement(
                    'div',
                    { id: 'nav-bar', className: this.state.navBarClasses },
                    _react2.default.createElement(
                        'div',
                        { className: 'module left' },
                        _react2.default.createElement(
                            'a',
                            { href: '//www.fantasylabs.com/' },
                            _react2.default.createElement('img', {
                                className: 'logo logo-light',
                                alt: 'FantasyLabs',
                                src: '//s3.amazonaws.com/si-fl-wp/wp-content/uploads/20171031160447/fl-an-logo-combo.png'
                            })
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        {
                            className: 'module widget-handle mobile-toggle right visible-sm visible-xs',
                            style: { lineHeight: '53px' },
                            onClick: this.handleMenuClick
                        },
                        _react2.default.createElement('i', { className: 'fas fa-bars gray-text' })
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'module-group right' },
                        _react2.default.createElement(
                            'div',
                            { className: 'module left', style: { paddingRight: '0' } },
                            _react2.default.createElement(
                                'ul',
                                { id: 'menu-fl-top-menu', className: 'menu' },
                                _react2.default.createElement(
                                    'li',
                                    {
                                        id: 'menu-item-15797',
                                        className: this.props.loginCookie !== 0 ? 'hide' : 'menu-tools menu-item menu-item-type-custom menu-item-object-custom menu-item-has-children menu-item-15797 has-dropdown'
                                    },
                                    _react2.default.createElement(
                                        'a',
                                        null,
                                        'Tools'
                                    ),
                                    _react2.default.createElement(
                                        'ul',
                                        { role: 'menu', className: 'subnav' },
                                        _react2.default.createElement(
                                            'li',
                                            {
                                                id: 'menu-item-15798',
                                                className: 'menu-item menu-item-type-custom menu-item-object-custom menu-item-15798'
                                            },
                                            _react2.default.createElement(
                                                'a',
                                                { href: this.props.baseUrl + '/tools/player-models/' },
                                                'Player Models'
                                            )
                                        ),
                                        _react2.default.createElement(
                                            'li',
                                            {
                                                id: 'menu-item-15799',
                                                className: 'menu-item menu-item-type-custom menu-item-object-custom menu-item-15799'
                                            },
                                            _react2.default.createElement(
                                                'a',
                                                { href: this.props.baseUrl + '/tools/trends/' },
                                                'DFS Trends'
                                            )
                                        ),
                                        _react2.default.createElement(
                                            'li',
                                            {
                                                id: 'menu-item-15800',
                                                className: 'menu-item menu-item-type-custom menu-item-object-custom menu-item-15800'
                                            },
                                            _react2.default.createElement(
                                                'a',
                                                { href: this.props.baseUrl + '/tools/lineup-builder/' },
                                                'Lineup Builder'
                                            )
                                        ),
                                        _react2.default.createElement(
                                            'li',
                                            {
                                                id: 'menu-item-17271',
                                                className: 'menu-item menu-item-type-custom menu-item-object-custom menu-item-has-children menu-item-17271 has-dropdown'
                                            },
                                            _react2.default.createElement(
                                                'a',
                                                null,
                                                'Sports'
                                            ),
                                            _react2.default.createElement(
                                                'ul',
                                                { role: 'menu', className: 'subnav' },
                                                _react2.default.createElement(
                                                    'li',
                                                    {
                                                        id: 'menu-item-17269',
                                                        className: 'menu-item menu-item-type-post_type menu-item-object-page menu-item-17269'
                                                    },
                                                    _react2.default.createElement(
                                                        'a',
                                                        { href: this.props.baseUrl + '/daily-fantasy-sports/nfl/' },
                                                        'NFL'
                                                    )
                                                ),
                                                _react2.default.createElement(
                                                    'li',
                                                    {
                                                        id: 'menu-item-17267',
                                                        className: 'menu-item menu-item-type-post_type menu-item-object-page menu-item-17267'
                                                    },
                                                    _react2.default.createElement(
                                                        'a',
                                                        { href: this.props.baseUrl + '/daily-fantasy-sports/nba/' },
                                                        'NBA'
                                                    )
                                                ),
                                                _react2.default.createElement(
                                                    'li',
                                                    {
                                                        id: 'menu-item-17270',
                                                        className: 'menu-item menu-item-type-post_type menu-item-object-page menu-item-17270'
                                                    },
                                                    _react2.default.createElement(
                                                        'a',
                                                        { href: this.props.baseUrl + '/daily-fantasy-sports/mlb/' },
                                                        'MLB'
                                                    )
                                                ),
                                                _react2.default.createElement(
                                                    'li',
                                                    {
                                                        id: 'menu-item-17268',
                                                        className: 'menu-item menu-item-type-post_type menu-item-object-page menu-item-17268'
                                                    },
                                                    _react2.default.createElement(
                                                        'a',
                                                        { href: this.props.baseUrl + '/daily-fantasy-sports/golf/' },
                                                        'GOLF'
                                                    )
                                                ),
                                                _react2.default.createElement(
                                                    'li',
                                                    {
                                                        id: 'menu-item-',
                                                        className: 'menu-item menu-item-type-post_type menu-item-object-page menu-item-'
                                                    },
                                                    _react2.default.createElement(
                                                        'a',
                                                        { href: this.props.baseUrl + '/daily-fantasy-sports/nhl/' },
                                                        'NHL'
                                                    )
                                                )
                                            )
                                        )
                                    )
                                ),
                                _react2.default.createElement(
                                    'li',
                                    {
                                        id: 'menu-item-14874-nfl',
                                        className: 'menu-item menu-item-type-custom menu-item-object-custom menu-item-has-children menu-item-14874 has-dropdown'
                                    },
                                    _react2.default.createElement(
                                        'a',
                                        {
                                            onClick: function onClick() {
                                                _this2.handleSubNavToggle('menu-item-14874-nfl');
                                            }
                                        },
                                        'NFL'
                                    ),
                                    _react2.default.createElement(
                                        'ul',
                                        { role: 'menu', className: 'subnav' },
                                        _react2.default.createElement(
                                            'li',
                                            {
                                                id: 'menu-item-14881',
                                                className: 'menu-item menu-item-type-custom menu-item-object-custom menu-item-14881'
                                            },
                                            _react2.default.createElement(
                                                'a',
                                                { href: this.props.baseUrl + '/daily-fantasy-football/' },
                                                'Home'
                                            )
                                        ),
                                        _react2.default.createElement(
                                            'li',
                                            {
                                                id: 'menu-item-14976',
                                                className: 'menu-item menu-item-type-custom menu-item-object-custom menu-item-14976'
                                            },
                                            _react2.default.createElement(
                                                'a',
                                                { href: this.props.baseUrl + '/nfl/player-models/' },
                                                'Models'
                                            )
                                        ),
                                        this.getSportDetails(1, 'sweatstation') ? _react2.default.createElement(
                                            'li',
                                            {
                                                id: 'menu-item-14976',
                                                className: 'menu-item menu-item-type-custom menu-item-object-custom menu-item-14976'
                                            },
                                            _react2.default.createElement(
                                                'a',
                                                { href: this.props.baseUrl + '/apps/sweatstation/nfl/0/4/0' },
                                                'Sweat Station'
                                            )
                                        ) : '',
                                        _react2.default.createElement(
                                            'li',
                                            {
                                                id: 'menu-item-15403',
                                                className: 'menu-item menu-item-type-custom menu-item-object-custom menu-item-15403'
                                            },
                                            _react2.default.createElement(
                                                'a',
                                                { href: this.props.baseUrl + '/nfl/trends/all/' },
                                                'Trends'
                                            )
                                        ),
                                        _react2.default.createElement(
                                            'li',
                                            {
                                                id: 'menu-item-15403',
                                                className: 'menu-item menu-item-type-custom menu-item-object-custom menu-item-15403'
                                            },
                                            _react2.default.createElement(
                                                'a',
                                                { href: this.props.baseUrl + '/nfl/contest-ownership/' },
                                                'Ownership'
                                            )
                                        ),
                                        _react2.default.createElement(
                                            'li',
                                            {
                                                id: 'menu-item-15403',
                                                className: 'menu-item menu-item-type-custom menu-item-object-custom menu-item-15403'
                                            },
                                            _react2.default.createElement(
                                                'a',
                                                { href: this.props.baseUrl + '/nfl/contests-dashboard/' },
                                                'Contest Dashboard'
                                            )
                                        ),
                                        _react2.default.createElement(
                                            'li',
                                            {
                                                id: 'menu-item-14885',
                                                className: 'menu-item menu-item-type-custom menu-item-object-custom menu-item-14885'
                                            },
                                            _react2.default.createElement(
                                                'a',
                                                { href: this.props.baseUrl + '/nfl/vegas/' },
                                                'Vegas'
                                            )
                                        ),
                                        _react2.default.createElement(
                                            'li',
                                            {
                                                id: 'menu-item-14977',
                                                className: 'menu-item menu-item-type-custom menu-item-object-custom menu-item-14977'
                                            },
                                            _react2.default.createElement(
                                                'a',
                                                { href: this.props.baseUrl + '/nfl/news/' },
                                                'News'
                                            )
                                        ),
                                        _react2.default.createElement(
                                            'li',
                                            {
                                                id: 'menu-item-9999',
                                                className: 'menu-item menu-item-type-custom menu-item-object-custom menu-item-9999'
                                            },
                                            _react2.default.createElement(
                                                'a',
                                                { href: this.props.baseUrl + '/nfl/matchups/' },
                                                'Matchups'
                                            )
                                        ),
                                        _react2.default.createElement(
                                            'li',
                                            {
                                                id: 'menu-item-',
                                                className: 'menu-item menu-item-type-custom menu-item-object-custom menu-item-'
                                            },
                                            _react2.default.createElement(
                                                'a',
                                                { href: this.props.baseUrl + '/tools/nfl/correlations/' },
                                                'Correlations'
                                            )
                                        ),
                                        this.getSportDetails(1, 'props') ? _react2.default.createElement(
                                            'li',
                                            {
                                                id: 'menu-item-',
                                                className: 'menu-item menu-item-type-custom menu-item-object-custom menu-item-'
                                            },
                                            _react2.default.createElement(
                                                'a',
                                                { href: this.props.baseUrl + '/apps/propositions/nfl/' },
                                                'Player Props'
                                            )
                                        ) : ''
                                    )
                                ),
                                _react2.default.createElement(
                                    'li',
                                    {
                                        id: 'menu-item-14874-nba',
                                        className: 'menu-item menu-item-type-custom menu-item-object-custom menu-item-has-children menu-item-14874 has-dropdown'
                                    },
                                    _react2.default.createElement(
                                        'a',
                                        {
                                            onClick: function onClick() {
                                                _this2.handleSubNavToggle('menu-item-14874-nba');
                                            }
                                        },
                                        'NBA'
                                    ),
                                    _react2.default.createElement(
                                        'ul',
                                        { role: 'menu', className: 'subnav' },
                                        _react2.default.createElement(
                                            'li',
                                            {
                                                id: 'menu-item-14882',
                                                className: 'menu-item menu-item-type-custom menu-item-object-custom menu-item-14882'
                                            },
                                            _react2.default.createElement(
                                                'a',
                                                { href: this.props.baseUrl + '/daily-fantasy-basketball/' },
                                                'Home'
                                            )
                                        ),
                                        _react2.default.createElement(
                                            'li',
                                            {
                                                id: 'menu-item-14982',
                                                className: 'menu-item menu-item-type-custom menu-item-object-custom menu-item-14982'
                                            },
                                            _react2.default.createElement(
                                                'a',
                                                { href: this.props.baseUrl + '/nba/player-models/' },
                                                'Models'
                                            )
                                        ),
                                        this.getSportDetails(2, 'lineups') ? _react2.default.createElement(
                                            'li',
                                            {
                                                id: 'menu-item-14976',
                                                className: 'menu-item menu-item-type-custom menu-item-object-custom menu-item-14976'
                                            },
                                            _react2.default.createElement(
                                                'a',
                                                { href: this.props.baseUrl + '/apps/lineups/nba/0/4' },
                                                'Lineup Builder Lite'
                                            )
                                        ) : '',
                                        this.getSportDetails(2, 'sweatstation') ? _react2.default.createElement(
                                            'li',
                                            {
                                                id: 'menu-item-14976',
                                                className: 'menu-item menu-item-type-custom menu-item-object-custom menu-item-14976'
                                            },
                                            _react2.default.createElement(
                                                'a',
                                                { href: this.props.baseUrl + '/apps/sweatstation/nba/0/4/0' },
                                                'Sweat Station'
                                            )
                                        ) : '',
                                        _react2.default.createElement(
                                            'li',
                                            {
                                                id: 'menu-item-14983',
                                                className: 'menu-item menu-item-type-custom menu-item-object-custom menu-item-14983'
                                            },
                                            _react2.default.createElement(
                                                'a',
                                                { href: this.props.baseUrl + '/nba/trends/all/' },
                                                'Trends'
                                            )
                                        ),
                                        _react2.default.createElement(
                                            'li',
                                            {
                                                id: 'menu-item-15403',
                                                className: 'menu-item menu-item-type-custom menu-item-object-custom menu-item-15403'
                                            },
                                            _react2.default.createElement(
                                                'a',
                                                { href: this.props.baseUrl + '/nba/contest-ownership/' },
                                                'Ownership'
                                            )
                                        ),
                                        _react2.default.createElement(
                                            'li',
                                            {
                                                id: 'menu-item-15403',
                                                className: 'menu-item menu-item-type-custom menu-item-object-custom menu-item-15403'
                                            },
                                            _react2.default.createElement(
                                                'a',
                                                { href: this.props.baseUrl + '/nba/contests-dashboard/' },
                                                'Contest Dashboard'
                                            )
                                        ),
                                        _react2.default.createElement(
                                            'li',
                                            {
                                                id: 'menu-item-',
                                                className: 'menu-item menu-item-type-custom menu-item-object-custom menu-item-'
                                            },
                                            _react2.default.createElement(
                                                'a',
                                                { href: this.props.baseUrl + '/nba/vegas/' },
                                                'Vegas'
                                            )
                                        ),
                                        _react2.default.createElement(
                                            'li',
                                            {
                                                id: 'menu-item-',
                                                className: 'menu-item menu-item-type-custom menu-item-object-custom menu-item-'
                                            },
                                            _react2.default.createElement(
                                                'a',
                                                { href: '//labs.actionnetwork.com/labs-nba-insiders' },
                                                'News'
                                            )
                                        ),
                                        _react2.default.createElement(
                                            'li',
                                            {
                                                id: 'menu-item-',
                                                className: 'menu-item menu-item-type-custom menu-item-object-custom menu-item-'
                                            },
                                            _react2.default.createElement(
                                                'a',
                                                { href: this.props.baseUrl + '/nba/matchups/' },
                                                'Matchups'
                                            )
                                        ),
                                        this.getSportDetails(2, 'props') ? _react2.default.createElement(
                                            'li',
                                            {
                                                id: 'menu-item-',
                                                className: 'menu-item menu-item-type-custom menu-item-object-custom menu-item-'
                                            },
                                            _react2.default.createElement(
                                                'a',
                                                { href: this.props.baseUrl + '/apps/propositions/nba/' },
                                                'Player Props'
                                            )
                                        ) : '',
                                        _react2.default.createElement(
                                            'li',
                                            {
                                                id: 'menu-item-',
                                                className: 'menu-item menu-item-type-custom menu-item-object-custom menu-item-'
                                            },
                                            _react2.default.createElement(
                                                'a',
                                                { href: this.props.baseUrl + '/nba/on-off/' },
                                                'On/Off'
                                            )
                                        )
                                    )
                                ),
                                _react2.default.createElement(
                                    'li',
                                    {
                                        id: 'menu-item-14874-mlb',
                                        className: 'menu-item menu-item-type-custom menu-item-object-custom menu-item-has-children menu-item-14874 has-dropdown'
                                    },
                                    _react2.default.createElement(
                                        'a',
                                        {
                                            onClick: function onClick() {
                                                _this2.handleSubNavToggle('menu-item-14874-mlb');
                                            }
                                        },
                                        'MLB'
                                    ),
                                    _react2.default.createElement(
                                        'ul',
                                        { role: 'menu', className: 'subnav' },
                                        _react2.default.createElement(
                                            'li',
                                            {
                                                id: 'menu-item-14884',
                                                className: 'menu-item menu-item-type-custom menu-item-object-custom menu-item-14884'
                                            },
                                            _react2.default.createElement(
                                                'a',
                                                { href: this.props.baseUrl + '/daily-fantasy-baseball/' },
                                                'Home'
                                            )
                                        ),
                                        _react2.default.createElement(
                                            'li',
                                            {
                                                id: 'menu-item-14972',
                                                className: 'menu-item menu-item-type-custom menu-item-object-custom menu-item-14972'
                                            },
                                            _react2.default.createElement(
                                                'a',
                                                { href: this.props.baseUrl + '/mlb/player-models/' },
                                                'Models'
                                            )
                                        ),
                                        this.getSportDetails(3, 'sweatstation') ? _react2.default.createElement(
                                            'li',
                                            {
                                                id: 'menu-item-14976',
                                                className: 'menu-item menu-item-type-custom menu-item-object-custom menu-item-14976'
                                            },
                                            _react2.default.createElement(
                                                'a',
                                                { href: this.props.baseUrl + '/apps/sweatstation/mlb/0/4/0' },
                                                'Sweat Station'
                                            )
                                        ) : '',
                                        _react2.default.createElement(
                                            'li',
                                            {
                                                id: 'menu-item-14973',
                                                className: 'menu-item menu-item-type-custom menu-item-object-custom menu-item-14973'
                                            },
                                            _react2.default.createElement(
                                                'a',
                                                { href: this.props.baseUrl + '/mlb/trends/all/' },
                                                'Trends'
                                            )
                                        ),
                                        _react2.default.createElement(
                                            'li',
                                            {
                                                id: 'menu-item-15403',
                                                className: 'menu-item menu-item-type-custom menu-item-object-custom menu-item-15403'
                                            },
                                            _react2.default.createElement(
                                                'a',
                                                { href: this.props.baseUrl + '/mlb/contest-ownership/' },
                                                'Ownership'
                                            )
                                        ),
                                        _react2.default.createElement(
                                            'li',
                                            {
                                                id: 'menu-item-15403',
                                                className: 'menu-item menu-item-type-custom menu-item-object-custom menu-item-15403'
                                            },
                                            _react2.default.createElement(
                                                'a',
                                                { href: this.props.baseUrl + '/mlb/contests-dashboard/' },
                                                'Contest Dashboard'
                                            )
                                        ),
                                        _react2.default.createElement(
                                            'li',
                                            {
                                                id: 'menu-item-14885',
                                                className: 'menu-item menu-item-type-custom menu-item-object-custom menu-item-14885'
                                            },
                                            _react2.default.createElement(
                                                'a',
                                                { href: this.props.baseUrl + '/mlb/vegas/' },
                                                'Vegas'
                                            )
                                        ),
                                        _react2.default.createElement(
                                            'li',
                                            {
                                                id: 'menu-item-14975',
                                                className: 'menu-item menu-item-type-custom menu-item-object-custom menu-item-14975'
                                            },
                                            _react2.default.createElement(
                                                'a',
                                                { href: this.props.baseUrl + '/mlb/news/' },
                                                'News'
                                            )
                                        ),
                                        _react2.default.createElement(
                                            'li',
                                            {
                                                id: 'menu-item-14969',
                                                className: 'menu-item menu-item-type-custom menu-item-object-custom menu-item-14969'
                                            },
                                            _react2.default.createElement(
                                                'a',
                                                { href: this.props.baseUrl + '/mlb/lineups/' },
                                                'Lineups'
                                            )
                                        ),
                                        this.getSportDetails(3, 'props') ? _react2.default.createElement(
                                            'li',
                                            {
                                                id: 'menu-item-',
                                                className: 'menu-item menu-item-type-custom menu-item-object-custom menu-item-'
                                            },
                                            _react2.default.createElement(
                                                'a',
                                                { href: this.props.baseUrl + '/apps/propositions/mlb/' },
                                                'Player Props'
                                            )
                                        ) : '',
                                        _react2.default.createElement(
                                            'li',
                                            {
                                                id: 'menu-item-',
                                                className: 'menu-item menu-item-type-custom menu-item-object-custom menu-item-'
                                            },
                                            _react2.default.createElement(
                                                'a',
                                                { href: this.props.baseUrl + '/tools/mlb/correlations/' },
                                                'Correlations'
                                            )
                                        )
                                    )
                                ),
                                _react2.default.createElement(
                                    'li',
                                    {
                                        id: 'menu-item-14874-golf',
                                        className: 'menu-item menu-item-type-custom menu-item-object-custom menu-item-has-children menu-item-14874 has-dropdown'
                                    },
                                    _react2.default.createElement(
                                        'a',
                                        {
                                            onClick: function onClick() {
                                                _this2.handleSubNavToggle('menu-item-14874-golf');
                                            }
                                        },
                                        'GOLF'
                                    ),
                                    _react2.default.createElement(
                                        'ul',
                                        { role: 'menu', className: 'subnav' },
                                        _react2.default.createElement(
                                            'li',
                                            {
                                                id: 'menu-item-14883',
                                                className: 'menu-item menu-item-type-custom menu-item-object-custom menu-item-14883'
                                            },
                                            _react2.default.createElement(
                                                'a',
                                                { href: this.props.baseUrl + '/daily-fantasy-golf/' },
                                                'Home'
                                            )
                                        ),
                                        _react2.default.createElement(
                                            'li',
                                            {
                                                id: 'menu-item-14878',
                                                className: 'menu-item menu-item-type-custom menu-item-object-custom menu-item-14878'
                                            },
                                            _react2.default.createElement(
                                                'a',
                                                { href: this.props.baseUrl + '/pga/player-models/' },
                                                'Models'
                                            )
                                        ),
                                        this.getSportDetails(5, 'lineups') ? _react2.default.createElement(
                                            'li',
                                            {
                                                id: 'menu-item-14976',
                                                className: 'menu-item menu-item-type-custom menu-item-object-custom menu-item-14976'
                                            },
                                            _react2.default.createElement(
                                                'a',
                                                { href: this.props.baseUrl + '/apps/lineups/pga/0/4' },
                                                'Lineup Builder Lite'
                                            )
                                        ) : '',
                                        this.getSportDetails(5, 'sweatstation') ? _react2.default.createElement(
                                            'li',
                                            {
                                                id: 'menu-item-14976',
                                                className: 'menu-item menu-item-type-custom menu-item-object-custom menu-item-14976'
                                            },
                                            _react2.default.createElement(
                                                'a',
                                                { href: this.props.baseUrl + '/apps/sweatstation/pga/0/4/0' },
                                                'Sweat Station'
                                            )
                                        ) : '',
                                        _react2.default.createElement(
                                            'li',
                                            {
                                                id: 'menu-item-14880',
                                                className: 'menu-item menu-item-type-custom menu-item-object-custom menu-item-14880'
                                            },
                                            _react2.default.createElement(
                                                'a',
                                                { href: this.props.baseUrl + '/pga/trends/all/' },
                                                'Trends'
                                            )
                                        ),
                                        _react2.default.createElement(
                                            'li',
                                            {
                                                id: 'menu-item-15403',
                                                className: 'menu-item menu-item-type-custom menu-item-object-custom menu-item-15403'
                                            },
                                            _react2.default.createElement(
                                                'a',
                                                { href: this.props.baseUrl + '/pga/contest-ownership/' },
                                                'Ownership'
                                            )
                                        ),
                                        _react2.default.createElement(
                                            'li',
                                            {
                                                id: 'menu-item-15403',
                                                className: 'menu-item menu-item-type-custom menu-item-object-custom menu-item-15403'
                                            },
                                            _react2.default.createElement(
                                                'a',
                                                { href: this.props.baseUrl + '/pga/contests-dashboard/' },
                                                'Contest Dashboard'
                                            )
                                        ),
                                        this.getSportDetails(5, 'props') ? _react2.default.createElement(
                                            'li',
                                            {
                                                id: 'menu-item-',
                                                className: 'menu-item menu-item-type-custom menu-item-object-custom menu-item-'
                                            },
                                            _react2.default.createElement(
                                                'a',
                                                { href: this.props.baseUrl + '/apps/propositions/pga/' },
                                                'Player Props'
                                            )
                                        ) : '',
                                        _react2.default.createElement(
                                            'li',
                                            {
                                                id: 'menu-item-',
                                                className: 'menu-item menu-item-type-custom menu-item-object-custom menu-item-'
                                            },
                                            _react2.default.createElement(
                                                'a',
                                                { href: this.props.baseUrl + '/tools/pga/correlations/' },
                                                'Correlations'
                                            )
                                        )
                                    )
                                ),
                                _react2.default.createElement(
                                    'li',
                                    {
                                        id: 'menu-item-14874-nhl',
                                        className: 'menu-item menu-item-type-custom menu-item-object-custom menu-item-has-children menu-item-14874 has-dropdown'
                                    },
                                    _react2.default.createElement(
                                        'a',
                                        {
                                            onClick: function onClick() {
                                                _this2.handleSubNavToggle('menu-item-14874-nhl');
                                            }
                                        },
                                        'NHL'
                                    ),
                                    _react2.default.createElement(
                                        'ul',
                                        { role: 'menu', className: 'subnav' },
                                        _react2.default.createElement(
                                            'li',
                                            {
                                                id: 'menu-item-14972',
                                                className: 'menu-item menu-item-type-custom menu-item-object-custom menu-item-14972'
                                            },
                                            _react2.default.createElement(
                                                'a',
                                                { href: this.props.baseUrl + '/nhl/player-models/' },
                                                'Models'
                                            )
                                        ),
                                        this.getSportDetails(4, 'lineups') ? _react2.default.createElement(
                                            'li',
                                            {
                                                id: 'menu-item-14976',
                                                className: 'menu-item menu-item-type-custom menu-item-object-custom menu-item-14976'
                                            },
                                            _react2.default.createElement(
                                                'a',
                                                { href: this.props.baseUrl + '/apps/lineups/nhl/0/4' },
                                                'Lineup Builder Lite'
                                            )
                                        ) : '',
                                        this.getSportDetails(4, 'sweatstation') ? _react2.default.createElement(
                                            'li',
                                            {
                                                id: 'menu-item-14976',
                                                className: 'menu-item menu-item-type-custom menu-item-object-custom menu-item-14976'
                                            },
                                            _react2.default.createElement(
                                                'a',
                                                { href: this.props.baseUrl + '/apps/sweatstation/nhl/0/4/0' },
                                                'Sweat Station'
                                            )
                                        ) : '',
                                        _react2.default.createElement(
                                            'li',
                                            {
                                                id: 'menu-item-14983',
                                                className: 'menu-item menu-item-type-custom menu-item-object-custom menu-item-14983'
                                            },
                                            _react2.default.createElement(
                                                'a',
                                                { href: this.props.baseUrl + '/nhl/trends/all/' },
                                                'Trends'
                                            )
                                        ),
                                        _react2.default.createElement(
                                            'li',
                                            {
                                                id: 'menu-item-15403',
                                                className: 'menu-item menu-item-type-custom menu-item-object-custom menu-item-15403'
                                            },
                                            _react2.default.createElement(
                                                'a',
                                                { href: this.props.baseUrl + '/nhl/contest-ownership/' },
                                                'Ownership'
                                            )
                                        ),
                                        _react2.default.createElement(
                                            'li',
                                            {
                                                id: 'menu-item-15403',
                                                className: 'menu-item menu-item-type-custom menu-item-object-custom menu-item-15403'
                                            },
                                            _react2.default.createElement(
                                                'a',
                                                { href: this.props.baseUrl + '/nhl/contests-dashboard/' },
                                                'Contest Dashboard'
                                            )
                                        ),
                                        _react2.default.createElement(
                                            'li',
                                            {
                                                id: 'menu-item-',
                                                className: 'menu-item menu-item-type-custom menu-item-object-custom menu-item-'
                                            },
                                            _react2.default.createElement(
                                                'a',
                                                { href: this.props.baseUrl + '/nhl/vegas/' },
                                                'Vegas'
                                            )
                                        ),
                                        _react2.default.createElement(
                                            'li',
                                            {
                                                id: 'menu-item-',
                                                className: 'menu-item menu-item-type-custom menu-item-object-custom menu-item-'
                                            },
                                            _react2.default.createElement(
                                                'a',
                                                { href: this.props.baseUrl + '/nhl/lines/' },
                                                'Team Lines'
                                            )
                                        ),
                                        _react2.default.createElement(
                                            'li',
                                            {
                                                id: 'menu-item-',
                                                className: 'menu-item menu-item-type-custom menu-item-object-custom menu-item-'
                                            },
                                            _react2.default.createElement(
                                                'a',
                                                { href: this.props.baseUrl + '/nhl/team-ratings/' },
                                                'Team Ratings'
                                            )
                                        ),
                                        _react2.default.createElement(
                                            'li',
                                            {
                                                id: 'menu-item-',
                                                className: 'menu-item menu-item-type-custom menu-item-object-custom menu-item-'
                                            },
                                            _react2.default.createElement(
                                                'a',
                                                { href: this.props.baseUrl + '/nhl/daily-starting-goalies/' },
                                                'Starting Goalies'
                                            )
                                        ),
                                        this.getSportDetails(4, 'props') ? _react2.default.createElement(
                                            'li',
                                            {
                                                id: 'menu-item-',
                                                className: 'menu-item menu-item-type-custom menu-item-object-custom menu-item-'
                                            },
                                            _react2.default.createElement(
                                                'a',
                                                { href: this.props.baseUrl + '/apps/propositions/nhl/' },
                                                'Player Props'
                                            )
                                        ) : ''
                                    )
                                ),
                                this.getSportDetails(6, 'multi-lineups') ? _react2.default.createElement(
                                    'li',
                                    {
                                        id: 'menu-item-14874-nhl',
                                        className: 'menu-item menu-item-type-custom menu-item-object-custom menu-item-has-children menu-item-14874 has-dropdown'
                                    },
                                    _react2.default.createElement(
                                        'a',
                                        {
                                            onClick: function onClick() {
                                                _this2.handleSubNavToggle('menu-item-14874-nhl');
                                            }
                                        },
                                        'NAS'
                                    ),
                                    _react2.default.createElement(
                                        'ul',
                                        { role: 'menu', className: 'subnav' },
                                        _react2.default.createElement(
                                            'li',
                                            {
                                                id: 'menu-item-14883',
                                                className: 'menu-item menu-item-type-custom menu-item-object-custom menu-item-14883'
                                            },
                                            _react2.default.createElement(
                                                'a',
                                                { href: this.props.baseUrl + '/daily-fantasy-nascar/' },
                                                'Home'
                                            )
                                        ),
                                        _react2.default.createElement(
                                            'li',
                                            {
                                                id: 'menu-item-14976',
                                                className: 'menu-item menu-item-type-custom menu-item-object-custom menu-item-14976'
                                            },
                                            _react2.default.createElement(
                                                'a',
                                                { href: this.props.baseUrl + '/nas/player-models/' },
                                                'Multi-Lineups'
                                            )
                                        )
                                    )
                                ) : '',
                                this.getSportDetails(10, 'multi-lineups') ? _react2.default.createElement(
                                    'li',
                                    {
                                        id: 'menu-item-14874-nhl',
                                        className: 'menu-item menu-item-type-custom menu-item-object-custom menu-item-has-children menu-item-14874 has-dropdown'
                                    },
                                    _react2.default.createElement(
                                        'a',
                                        {
                                            onClick: function onClick() {
                                                _this2.handleSubNavToggle('menu-item-14874-nhl');
                                            }
                                        },
                                        'MMA'
                                    ),
                                    _react2.default.createElement(
                                        'ul',
                                        { role: 'menu', className: 'subnav' },
                                        _react2.default.createElement(
                                            'li',
                                            {
                                                id: 'menu-item-14976',
                                                className: 'menu-item menu-item-type-custom menu-item-object-custom menu-item-14976'
                                            },
                                            _react2.default.createElement(
                                                'a',
                                                { href: this.props.baseUrl + '/mma/player-models/' },
                                                'Multi-Lineups'
                                            )
                                        )
                                    )
                                ) : '',
                                this.getSportDetails(18, 'multi-lineups') || this.getSportDetails(20, 'multi-lineups') ? _react2.default.createElement(
                                    'li',
                                    {
                                        id: 'menu-item-14874-nhl',
                                        className: 'menu-item menu-item-type-custom menu-item-object-custom menu-item-has-children menu-item-14874 has-dropdown'
                                    },
                                    _react2.default.createElement(
                                        'a',
                                        {
                                            onClick: function onClick() {
                                                _this2.handleSubNavToggle('menu-item-14874-nhl');
                                            }
                                        },
                                        'ESPORTS'
                                    ),
                                    _react2.default.createElement(
                                        'ul',
                                        { role: 'menu', className: 'subnav' },
                                        _react2.default.createElement(
                                            'li',
                                            {
                                                id: 'menu-item-14883',
                                                className: 'menu-item menu-item-type-custom menu-item-object-custom menu-item-14883'
                                            },
                                            _react2.default.createElement(
                                                'a',
                                                { href: this.props.baseUrl + '/fantasy-esports/' },
                                                'Home'
                                            )
                                        ),
                                        this.getSportDetails(18, 'multi-lineups') ? _react2.default.createElement(
                                            'li',
                                            {
                                                id: 'menu-item-14976',
                                                className: 'menu-item menu-item-type-custom menu-item-object-custom menu-item-14976'
                                            },
                                            _react2.default.createElement(
                                                'a',
                                                { href: this.props.baseUrl + '/lol/player-models/' },
                                                'LOL - Multi-Lineups'
                                            )
                                        ) : '',
                                        this.getSportDetails(20, 'multi-lineups') ? _react2.default.createElement(
                                            'li',
                                            {
                                                id: 'menu-item-14976',
                                                className: 'menu-item menu-item-type-custom menu-item-object-custom menu-item-14976'
                                            },
                                            _react2.default.createElement(
                                                'a',
                                                { href: this.props.baseUrl + '/csgo/player-models/' },
                                                'CSGO - Multi-Lineups'
                                            )
                                        ) : '',
                                        this.getSportDetails(22, 'multi-lineups') ? _react2.default.createElement(
                                            'li',
                                            {
                                                id: 'menu-item-14976',
                                                className: 'menu-item menu-item-type-custom menu-item-object-custom menu-item-14976'
                                            },
                                            _react2.default.createElement(
                                                'a',
                                                { href: this.props.baseUrl + '/cod/player-models/' },
                                                'COD - Multi-Lineups'
                                            )
                                        ) : ''
                                    )
                                ) : '',
                                _react2.default.createElement(
                                    'li',
                                    {
                                        id: 'menu-item-14875',
                                        className: 'menu-item menu-item-type-custom menu-item-object-custom menu-item-14875'
                                    },
                                    _react2.default.createElement(
                                        'a',
                                        { href: this.props.baseUrl + '/articles/' },
                                        'Articles'
                                    )
                                ),
                                _react2.default.createElement(
                                    'li',
                                    {
                                        className: this.props.loginCookie !== 0 ? 'menu-item menu-item-type-custom menu-item-object-custom menu-item-14970' : 'menu-item menu-item-type-custom menu-item-object-custom menu-item-14970 hide'
                                    },
                                    _react2.default.createElement(
                                        'a',
                                        { href: this.props.baseUrl + '/support/' },
                                        'Support'
                                    )
                                )
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            {
                                id: 'menuItemLogin',
                                className: this.props.loginCookie !== 0 ? 'module widget-handle uppercase left hide' : 'module widget-handle uppercase left'
                            },
                            _react2.default.createElement(
                                'a',
                                { className: 'btn btn-success btn-signup', href: this.props.baseUrl + '/pricing/' },
                                'Signup'
                            ),
                            '\xA0',
                            _react2.default.createElement(
                                'a',
                                { className: 'btn btn-login', href: this.props.baseUrl + '/account/login/' },
                                'Login'
                            )
                        ),
                        _react2.default.createElement(
                            'div',
                            {
                                id: 'menuItemMyAccount',
                                className: this.props.loginCookie !== 0 ? 'module widget-handle uppercase left' : 'module widget-handle uppercase left hide',
                                style: { paddingLeft: '0', paddingRight: '0' }
                            },
                            _react2.default.createElement(
                                'ul',
                                { id: 'menu-my-account-menu', className: 'menu' },
                                _react2.default.createElement(
                                    'li',
                                    {
                                        id: 'menu-item-14877',
                                        className: 'menu-item menu-item-type-custom menu-item-object-custom menu-item-has-children menu-item-14877 has-dropdown'
                                    },
                                    _react2.default.createElement(
                                        'a',
                                        {
                                            onClick: function onClick() {
                                                _this2.handleSubNavToggle('menu-item-14877');
                                            }
                                        },
                                        'My Account'
                                    ),
                                    _react2.default.createElement(
                                        'ul',
                                        { role: 'menu', className: ' subnav' },
                                        _react2.default.createElement(
                                            'li',
                                            {
                                                id: 'menu-item-14987',
                                                className: 'menu-item menu-item-type-custom menu-item-object-custom menu-item-14987'
                                            },
                                            _react2.default.createElement(
                                                'a',
                                                { href: this.props.baseUrl + '/subscription/my-account/' },
                                                'Subscriptions'
                                            )
                                        ),
                                        _react2.default.createElement(
                                            'li',
                                            {
                                                id: 'menu-item-14988',
                                                className: 'menu-item menu-item-type-custom menu-item-object-custom menu-item-14988'
                                            },
                                            _react2.default.createElement(
                                                'a',
                                                { onClick: this.props.handleLogout },
                                                'Logout'
                                            )
                                        )
                                    )
                                )
                            )
                        )
                    )
                )
            );
            return navBar;
        }
    }]);

    return NavBar;
}(_react.Component);

exports.default = NavBar;


//////////////////
// WEBPACK FOOTER
// ../component-library/build/navigation/NavBar.js
// module id = 362
// module chunks = 0